<div class="container">
  @let offer = challenge();
  @if (offer.type === OfferType.FREQUENCY) {
    @let frequencyLabel = config().frequencyVisitsLabel;
    @let frequencyText =
      frequencyLabel.textBySubType?.[offer.subType] ??
      frequencyLabel.textBySubType?.[SubType.DEFAULT] ??
      '';
    <p
      class="frequency-visit-text"
      [style]="{
        color: frequencyLabel.textColor,
        fontFamily: frequencyLabel.fontFamily,
      }"
      [innerHTML]="frequencyText | replaceVars: offer.target | safe"
    ></p>
  }
  <div class="label-container">
    @let offerLabel = config().offerLabel;
    <p
      class="label"
      [style]="{
        color: offerLabel.color,
        fontFamily: offerLabel.fontFamily,
      }"
    >
      {{
        offerLabel.textByType[offer.type] ??
          offerLabel.textByType[OfferType.STEP] ??
          ''
      }}
    </p>
    <div
      class="reward"
      [style]="{
        color: config().rewardContainer.textColor,
        backgroundColor: config().rewardContainer.backgroundColor,
        fontFamily: config().rewardContainer.fontFamily,
      }"
    >
      <span [innerHTML]="maxReward() | formatReward | safe"></span>
    </div>

    <p
      class="suffix-label"
      [style]="{
        color: config().suffixLabel.color,
        fontFamily: config().suffixLabel.fontFamily,
      }"
    >
      {{ config().suffixLabel.text }}
    </p>
  </div>
  <div class="button-container">
    <b2c-button
      [styles]="{
        fontSize: '14px',
        width: '250px',
        padding: '0.5rem 1rem',
        border: 'none',
        color: config().button.color,
        fontFamily: config().button.fontFamily,
        backgroundColor: config().button.backgroundColor,
      }"
      data-cy="select_btn"
      [title]="config().button.title"
      [loading]="selectionInProgress()"
      [attr.aria-label]="config().button.title"
      (click)="
        selectChallenge(
          challenge(),
          phase(),
          isBisCampaign(),
          isEventChallenge()
        )
      "
      [disabled]="
        challenge().isOutOfStock() ||
        selectionInProgress() ||
        blockSelectionButton()
      "
    >
      <img
        class="trophy-icon"
        [src]="config().button.icon.imageUrl"
        [alt]="config().button.icon.alternativeText"
      />
      {{ config().button.label }}
    </b2c-button>
  </div>
</div>
